import {HttpClient, HttpContext, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';

type HttpOptions = {
  headers?:
    | HttpHeaders
    | {
        [header: string]: string | string[];
      };
  observe?: any;
  context?: HttpContext;
  params?:
    | HttpParams
    | {
        [param: string]:
          | number
          | boolean
          | string
          | ReadonlyArray<string | number | boolean>;
      };
  reportProgress?: boolean;
  responseType?: 'json';
  withCredentials?: boolean;
};

const AUTHORIZATION_HEADER_KEY = 'Authorization';

export abstract class HttpService {
  readonly api: string | undefined;

  readonly token: ((...args: any[]) => string) | undefined;

  readonly http!: HttpClient;

  get authorizationHeader(): string | undefined {
    return this.token ? this.token() : undefined;
  }

  get<T>(endpoint: string, options?: HttpOptions): Observable<T> {
    return this.http.get<T>(this.api + endpoint, this._extractOptions(options));
  }

  post<T>(endpoint: string, body: unknown | null, options?: HttpOptions): Observable<T> {
    return this.http.post<T>(this.api + endpoint, body, this._extractOptions(options));
  }

  put<T>(endpoint: string, body: unknown | null, options?: HttpOptions): Observable<T> {
    return this.http.put<T>(this.api + endpoint, body, this._extractOptions(options));
  }

  patch<T>(endpoint: string, body: unknown | null, options?: HttpOptions): Observable<T> {
    return this.http.patch<T>(this.api + endpoint, body, this._extractOptions(options));
  }

  delete<T>(endpoint: string, options?: HttpOptions): Observable<T> {
    return this.http.delete<T>(this.api + endpoint, this._extractOptions(options));
  }

  private _extractOptions(options: HttpOptions | undefined): HttpOptions | undefined {
    if (!options) {
      return this.authorizationHeader
        ? {
            headers: new HttpHeaders({
              [AUTHORIZATION_HEADER_KEY]: this.authorizationHeader as string,
            }),
          }
        : undefined;
    }

    const authorizationHeader = (options.headers as HttpHeaders)?.get(
      AUTHORIZATION_HEADER_KEY,
    );

    if (authorizationHeader) {
      return options;
    }

    return {
      ...options,
      headers: new HttpHeaders({
        ...options?.headers,
        [AUTHORIZATION_HEADER_KEY]: this.authorizationHeader as string,
      }),
    };
  }
}
